import type { RelanceAgendaEntry } from '../../types/customerFollowUp/relanceAgenda';

// An expected row's id names the customer, not a relance: the payment is recorded on its open relance, if any.
export const collectableRelance = (entry: RelanceAgendaEntry) => ({
    id: entry.status === 'expected' ? entry.relanceId ?? null : entry.item.id,
    customerExternalId: entry.item.customerExternalId,
    totalDue: entry.item.totalDue,
});
